import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const ShareIcon = ({
  width = "24",
  height = "24",
  color = "#1C3C6C",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} color={color}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.4849 19.9994C20.4842 20.2772 20.426 20.5518 20.3138 20.8059C20.2016 21.0599 20.0379 21.2879 19.8332 21.4752C19.6284 21.6626 19.387 21.8053 19.1243 21.8943C18.8617 21.9833 18.5834 22.0166 18.3071 21.9923C18.0309 21.9679 17.7627 21.8862 17.5196 21.7526C17.2765 21.6189 17.0638 21.4361 16.8949 21.2157C16.7261 20.9954 16.6047 20.7423 16.5387 20.4725C16.4726 20.2027 16.4631 19.922 16.511 19.6484L14.0585 18.5353C13.8711 18.7683 13.6341 18.9563 13.3648 19.0855C13.0954 19.2148 12.8006 19.2821 12.502 19.2824C11.971 19.2824 11.4618 19.0711 11.0864 18.695C10.7109 18.3189 10.5 17.8087 10.5 17.2768C10.5 16.7449 10.7109 16.2348 11.0864 15.8587C11.4618 15.4826 11.971 15.2713 12.502 15.2713C12.7765 15.2722 13.0479 15.3296 13.2993 15.44C13.5507 15.5504 13.7768 15.7114 13.9634 15.9131L16.546 14.5092C16.501 14.3459 16.479 14.1771 16.4809 14.0078C16.4804 13.5412 16.6423 13.089 16.9388 12.7291C17.2353 12.3692 17.6477 12.1241 18.1051 12.036C18.5625 11.948 19.0363 12.0225 19.4448 12.2466C19.8533 12.4708 20.171 12.8307 20.3431 13.2642C20.5153 13.6978 20.5312 14.1779 20.388 14.622C20.2449 15.066 19.9516 15.4461 19.5588 15.6969C19.166 15.9476 18.6982 16.0534 18.236 15.9958C17.7738 15.9383 17.3461 15.721 17.0265 15.3816L14.4439 16.7905C14.489 16.9546 14.5107 17.1217 14.509 17.2919C14.5093 17.4095 14.4992 17.527 14.479 17.6429L16.9314 18.7559C17.1908 18.4294 17.5453 18.192 17.9457 18.0769C18.3461 17.9618 18.7724 17.9746 19.1651 18.1137C19.5579 18.2528 19.8976 18.5111 20.1368 18.8527C20.3761 19.1943 20.503 19.6021 20.4999 20.0194L20.4849 19.9994Z"
          fill={color}
        />
        <path
          d="M11 9.75C12.627 9.75 15.4877 10.4148 16.8027 11.7363L10.875 15H4.5V13.25C4.5 10.9225 8.83875 9.75 11 9.75ZM11 2C12.8038 2 14.25 3.5575 14.25 5.5C14.25 7.4425 12.8038 9 11 9C10.138 9 9.31164 8.63099 8.70215 7.97461C8.09267 7.31823 7.75 6.42825 7.75 5.5C7.75 4.57175 8.09267 3.68177 8.70215 3.02539C9.31164 2.36901 10.138 2 11 2Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
